import { apiInstance } from 'api/utils';
import { FormValues as AssetUpdateType } from 'components/Forms/AssetsDetails';
const URLS = {
  ASSETS: '/assets/',
};

export default {
  createAsset: (data: any) =>
    apiInstance.request({
      method: 'POST',
      url: URLS.ASSETS,
      data: data,
    }),
  getAssets: (params?: { limit: string; offset: string }) =>
    apiInstance.request({
      method: 'GET',
      url: URLS.ASSETS,
      params,
    }),
  removeAssets: ({ uuid }: { uuid: string }) =>
    apiInstance.request({
      method: 'DELETE',
      url: `${URLS.ASSETS}/${uuid}/`,
    }),
  updateAssets: ({ uuid, values }: { uuid: string; values: AssetUpdateType }) =>
    apiInstance.request({
      method: 'PATCH',
      url: `${URLS.ASSETS}/${uuid}/`,
      data: values,
    }),
};
